import { render, staticRenderFns } from "./serviceDesk.vue?vue&type=template&id=8a5380d8&scoped=true&"
import script from "./serviceDesk.vue?vue&type=script&lang=js&"
export * from "./serviceDesk.vue?vue&type=script&lang=js&"
import style0 from "./serviceDesk.vue?vue&type=style&index=0&id=8a5380d8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5380d8",
  null
  
)

export default component.exports